import { h } from 'preact';
import { useRef } from 'preact/hooks';
import PropTypes from 'prop-types';

import { useSlider } from '../../../hooks/use-slider';
import Label from '../../2-atoms/label/label';

const DEFAULT_TARGET = '_self';
const DEFAULT_INTCMP = '';

const TagList = ({ tags, targetCta = DEFAULT_TARGET, intcmpTag = DEFAULT_INTCMP }) => {
  const tagListRef = useRef();
  useSlider(tagListRef);

  return (
    <ul className="c-tag-list l-spacing-s u-slider" ref={tagListRef}>
      {tags.map((tag) => (
        <li className="c-tag-list__item" key={tag.name}>
          <Label tag="a" url={tag.url} target={targetCta} intcmpTag={intcmpTag} modifiers={['tag-parsely']}>
            {tag.name}
          </Label>
        </li>
      ))}
    </ul>
  );
};

TagList.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    })
  ).isRequired,
  targetCta: PropTypes.string,
  intcmpTag: PropTypes.string,
};

export default TagList;
